module.exports = __webpack_public_path__ + "media/media/about/2-b06f5f0c27bc13bcc61da01b901b9b75.jpg";